import { Box, Button, FormLabel, Grid, Stack, TextField, InputAdornment, } from '@mui/material'
import React from 'react'
import loginimg from '../../../src/assets/images/login/login2.jpg'
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useForgotPasswordMutation } from '../../app/services/loginServices';
import { toast } from 'react-toastify';
import PersonIcon from "@mui/icons-material/Person";
const Forgotpassword = () => {
  const navigate = useNavigate();
  const { register, formState: { errors }, handleSubmit } = useForm({
    defaultValues: {
      userId: ''
    }
  })
  const [forgotPass] = useForgotPasswordMutation()

  //Form submission
  const submitHandler = (formData) => {
    const { username, ...rest } = formData
    forgotPass(rest).then(res => {
      if (res?.data?.status) {
        toast.success(res?.data?.message)
        navigate('/login')
      }
      else {
        toast.error(res?.data?.message)
      }
    })
  }

  return (
    <>
      <Grid container className='login-page'>
        <Grid item xs={12} md={6} lg={6} >
          <img src={`${process.env.REACT_APP_PUBLIC_URL}/assets/images/logos/ELTA@I.svg`} className="logo" alt="logo" height={75} onClick={() => navigate('/')} />
          <img src={loginimg} alt="Login" className="img-fluid h-100" style={{ objectFit: 'cover' }} />
        </Grid>
        <Grid item xs={12} md={6} lg={6} className='d-flex justify-content-center align-items-center flex-column'>
          <h1 className="text-white fs-3">Let’s get Knowledge!</h1>
          <h2 className="text-white fs-4 lead display-3 text-capitalize">Join with ELT@I to start creating magic.</h2>
          <Box mt={3} component={'form'} onSubmit={handleSubmit(submitHandler)}>
            <Stack direction={'column'}>
              <Stack className='w-100 mb-3'>
                <FormLabel className='text-white mb-3'>Enter a User ID to send link to change password</FormLabel>
                <TextField
                  id="user_id"
                  placeholder="User ID"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon className="text-white fs-2" />
                      </InputAdornment>
                    ),
                    style: { color: 'white' }
                  }}
                  fullWidth
                  {...register("userId", {
                    required: "Please enter user Id",
                  })}
                  type="text"
                  error={!!errors?.userId}
                  helperText={errors?.userId?.message}
                  autoFocus
                  sx={{
                    width: "100%",
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: 'none'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: 'white'
                      },
                    }
                  }}>
                </TextField>
              </Stack>
              <Stack direction={'row'} gap={3} justifyContent={"space-between"}>
                <Button onClick={() => { window.history.back() }} type='button' variant='outlined' style={{ color: "white", borderColor: "white", width: '100%' }} tabIndex={-1}>Back</Button>
                <Button type='submit' variant='contained' className='login-btn' style={{ width: '100%' }}>Submit</Button>
              </Stack>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default Forgotpassword